import React, { useState, useEffect, useRef } from 'react'
import styles from './styles.module.css'
import useApi from 'src/hooks/useApi'
import services from 'src/api/service'
import { CaretDownIcon } from './Caret-Down'
import { COUNTRIES } from 'src/config/constant'

export const CustomCountryDropdown = (props) => {
  const [countries, setCountries] = useState(COUNTRIES)
  const [countriesCopy, setCountriesCopy] = useState(COUNTRIES)
  const [open, setOpen] = useState(false)
  const [defaultCountry, setDefaultCountry] = useState({})
  const [activeCountryCode, setActiveCountryCode] = useState(null) // State for active country
  const [shouldOpenUpward, setShouldOpenUpward] = useState(false) // State to track actual dropdown direction
  const { allowUpwardDropdownDirection = false } = props

  const getCountries = useApi(services.getService)

  const dropdownRef = useRef(null)

  const checkAvailableSpace = () => {
    if (!dropdownRef.current) return false

    const rect = dropdownRef.current.getBoundingClientRect()
    const viewportHeight = window.innerHeight
    const dropdownHeight = 250 // max height (200px) + padding
    
    const spaceBelow = viewportHeight - rect.bottom
    const spaceAbove = rect.top

    if (allowUpwardDropdownDirection) {
      return spaceBelow < dropdownHeight && spaceAbove > dropdownHeight
    }
    
    return false
  }

  useEffect(() => {
    defaultCountrySetter(props.countryCode ? COUNTRIES.find((country_row) => (country_row.country_code === props.countryCode)) : {
        "country_name": "US",
        "country_code": "US",
        "region_name": "north_america",
        "url_prefix": "https://www.amazon.com/ap/oa",
        "currencyCode": "USD"
    })
    document.addEventListener('mousedown', handleClickOutSide)

    const handleResize = () => {
      if (open && allowUpwardDropdownDirection) {
        setShouldOpenUpward(checkAvailableSpace())
      }
    }
    window.addEventListener('resize', handleResize)

    if (props.isShowAllCountries) {
      getAllCountries();
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutSide)
      window.removeEventListener('resize', handleResize)
    }
  }, [open, allowUpwardDropdownDirection])

  const getAllCountries = async () => {
    await preFetchCountries().then((result) => {
      console.log('result', result)
      const countries = result.map((country) => ({
        country_name: country.name,
        country_code: country.alpha2Code
      }))
      setCountries(countries);
      setCountriesCopy(countries);
    })
  }

  const defaultCountrySetter = (dResponse) => {
    setDefaultCountry(dResponse)
    setActiveCountryCode(dResponse.country_code) // Set active country code
  }

  const preFetchCountries = async () => {
    const data = await fetch('https://restcountries.com/v2/all?fields=name,alpha2Code')
    const result = await data.json()
    return result
  }

  const handleClickOutSide = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setOpen(false)
    }
  }

  const toggleDropDown = () => {
    /* reset all countries before closing */
    if (!open) {
      setCountries(countriesCopy)
      if (allowUpwardDropdownDirection) {
        setShouldOpenUpward(checkAvailableSpace())
      }
    }
    setOpen(!open)
  }

  const handleCountryClick = (country) => {
    const result = {...country, code: country.country_code}
    setDefaultCountry(result)
    setActiveCountryCode(country.country_code) // Update active country code

    if (props.onSelect) {
      props.onSelect(result)
    }

    /* Hide the dropdown menu on selecting a country */
    toggleDropDown()
  }

  const handleSearchInput = (e) => {
    const input = e.target.value.toLowerCase()
    let filteredCountries = countriesCopy.filter((i) =>
      i.country_name.toLowerCase().includes(input.toLowerCase())
    )
    setCountries(filteredCountries)
  }

  return (
    <div className={`${styles.container} drop-down-container`} ref={dropdownRef}>
      <div className={`${styles.dropdown} drop-down-form-field`} onClick={toggleDropDown}>
        {props?.hideFlag ? null : <img
          className={styles.country_flag}
          src={defaultCountry?.country_code?.toLowerCase() === 'uk' ? 'https://flagpedia.net/data/flags/w1160/gb.webp' : `https://flagcdn.com/${defaultCountry?.country_code?.toLowerCase()}.svg`}
          alt={defaultCountry?.country_name}
        />}
        <span className={`${styles.selected_country} custom-select-text ${props?.hideFlag ? 'ml-0' : ''}`}>
          {props.showFullName ? defaultCountry?.country_name : defaultCountry?.country_code}
        </span>
        <CaretDownIcon point={open ? 'up' : 'down'} />
      </div>

      {open && (
        <div className={`${styles.dropdown_items_wrapper} ${shouldOpenUpward ? styles.dropdown_upward : ''} custom-wrapper-select`}>
          <div className={styles.input_wrapper}>
            <input
              onChange={(e) => handleSearchInput(e)}
              className={styles.country_search}
              type='text'
              placeholder='search countries...'
            />
          </div>

          <div className={styles.dropdown_items}>
            {countries.map((i, index) => {
              return (
                <div
                  key={index}
                  onClick={() => handleCountryClick(i)}
                  className={`${styles.dropdown_item} ${i.country_code === activeCountryCode ? styles.country_flag_active : ''}`}>
                  <img className={styles.country_flag} src={i.country_code.toLowerCase() === 'uk' ? 'https://flagpedia.net/data/flags/w1160/gb.webp' : `https://flagcdn.com/${i.country_code.toLowerCase()}.svg`} alt='' />
                  <span className={styles.dropdown_item_title}> {i.country_name}</span>
                  {i.country_code === activeCountryCode && <span className={styles.green_dot}></span>}
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}
